export const SET_ADMIN_AUDIT_SEARCH_BOWLER_VALUE = 'SET_ADMIN_AUDIT_SEARCH_BOWLER_VALUE';
export const SET_ADMIN_AUDIT_SEARCH_BOWLERS = 'SET_ADMIN_AUDIT_SEARCH_BOWLERS';
export const SET_ADMIN_AUDIT_BOWLER_HEADER = 'SET_ADMIN_AUDIT_BOWLER_HEADER';
export const SET_ADMIN_AUDIT_BOWLER_DETAILS = 'SET_ADMIN_AUDIT_BOWLER_DETAILS';



// WEBPACK FOOTER //
// ./src/features/admin/audit/bowlerAudit/constants.js